/**
 * Main Application File
 *
 * Use for bootstrapping large application
 * or just fill it with JS on small projects
 *
 */

import 'babel-polyfill'; //explicitly import the polyfill
import './base/plugins';

import Barba from 'barba.js';

import FastClick from 'fastclick';

import App from './containers/App';

import Common from './base/common';

import { PageTransition, PageToArticle, ArticleToPage } from './base/page-transition';

import { data } from './base/dom-utils';

// if (Common.mq('desktop') || !Modernizr.touchevents) {
//
//     SmoothScroll({
//         animationTime: 1000,
//         animationStep: 20,
//         accelerationDelta: 50,
//         accelerationMax: 2,
//     });
// }


FastClick.attach(document.body);

document.addEventListener('DOMContentLoaded', function() {
    let lastElementClicked,
        currentNamespace;

    Barba.Pjax.init();
    Barba.Prefetch.init();

    Barba.Dispatcher.on('linkClicked', function (el) {
        lastElementClicked = el;
        currentNamespace = data('namespace', lastElementClicked);
    });

    Barba.Pjax.getTransition = () => {

        var prevNamespace = Barba.Pjax.History.prevStatus().namespace;

        if (prevNamespace !== 'single' && currentNamespace === 'single') {
            return PageToArticle;
        } else if (prevNamespace === 'single' && currentNamespace !== 'single') {
            return ArticleToPage;
        } else {
            return PageTransition;
        }

    }
});

new App('#barba-wrapper').init();




/** WEBPACK FOOTER **
 ** ./app.js
 **/